// $( "#showAllCategories" ).click(function() {
//     $('.asideCategories').addClass('openCategories');
// });


$( "#showAllFilters" ).click(function() {
    $('.asideCategories').addClass('openFilters');
});


$( ".asideCategories__canvas-overlay , .asideCategories__btn-close" ).click(function() {
    $('.asideCategories').removeClass('openCategories openFilters');
});
